import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectOrgaoComponent } from './select-orgao/select-orgao.component';
import { DropdownModule } from 'primeng/dropdown';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectUpagComponent } from './select-upag/select-upag.component';
import { SelectUorgComponent } from './select-uorg/select-uorg.component';
import { SharedModule } from '../shared.module';

@NgModule({
    declarations: [SelectOrgaoComponent, SelectUpagComponent, SelectUorgComponent],
    exports: [SelectOrgaoComponent, SelectUpagComponent, SelectUorgComponent],
    imports: [CommonModule, SharedModule, DropdownModule, ReactiveFormsModule]
})
export class OrgaoModule {}
